<template>
	<div v-if="item.item_type_config && item.item_type_config.product_data_summary" class="cd-variations variations">
		<div v-for="(variation, key) in item.item_type_config.product_data_summary" :key="key" class="variation">
			<div class="variation-title">{{ item.item_type_config?.attribute_data?.[key]?.title }}</div>
			<div :class="['variation-items', 'variation-item_' + item.item_type_config.attribute_data?.[key]?.code + '']">
				<div
					v-for="(variationItem, key) in variation"
					:key="key"
					@click="chooseVar(variationItem, variationItem.data.id, variationItem.data.attribute_id)"
					:style="'order:' + variationItem.data.position"
					:class="[
						'attribute',
						'variation-attribute',
						'variation-button',
						{
							'special': variationItem.data.image_upload_path,
							'active': (item.primary_product_id && item.primary_product_id == variationItem.data.active) || (item.primary_product_data && item.primary_product_data.id == variationItem.data.active) || item.id == variationItem.data.active,
						},
						getClass(variationItem, variationItem.data.code, variationItem.data.attribute_id)
					]">
					<span v-if="variationItem.data.image_upload_path" class="img">
						<BaseUiImage :src="variationItem.data.image_upload_path" width="42" height="42" :alt="variationItem.data.title" />
					</span>
					<span v-if="!variationItem.data.image_upload_path" class="title">{{ variationItem.data.title }}</span>
				</div>
			</div>
		</div>
	</div>

	<div v-if="item.type == 'advanced' && item.type_config" class="variations">
		<div class="variation">
			<div class="variation-title">
				{{ item.attribute_title }}: <strong class="strong">{{ advancedItemTitle }}</strong>
			</div>
			<div class="variation-items">
				<div v-for="(item, key) in item.type_config" :key="key" @click="chooseAdvancedVar(key, item.title)" :class="['attribute', 'variation-attribute', 'variation-' + item.code + '', {'active': advancedItem && advancedItem == key}]">
					<span class="title">{{ item.title }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['item', 'mode']);
	const {emit, bus} = useEventBus();
	let isAvailable = ref([]);

	//conf item
	function chooseVar(data, id, attributeId) {
		//find all active attributes and exclude the attribute from the group that is clicked
		const activeVariationItems = Object.values(props.item.item_type_config.product_data_summary)
		.flatMap((variation) => Object.values(variation))
		.filter((variationItem) => variationItem.data.active == props.item.id && variationItem.data.attribute_id != attributeId)
		.map((variationItem) => variationItem.data.id);

		//add the id of attribute on which the user clicked
		activeVariationItems.push(data.data.id);

		//find offer shopping cart code for product that have values from the activeVariationItems array
		const product = Object.values(props.item.item_type_config.product_data).filter((obj) =>
			obj.configurable_attribute_items_ids.every((value) => activeVariationItems.includes(value))
		);
		if(!product.length) {
			// If product array is empty, find the first item with the same id in configurable_attribute_items_ids
			const fallbackProduct = Object.values(props.item.item_type_config.product_data).find((obj) =>
				obj.configurable_attribute_items_ids.includes(id)
			);

			if (fallbackProduct) {
				const productCartCode = [fallbackProduct.offer_shopping_cart_code];
				emit('confItem', productCartCode);
			}
		} else {
			const productCartCode = product.map((obj) => obj.offer_shopping_cart_code);

			emit('confItem', productCartCode);
		}
	}


	function checkIfAvailable() {
		// Found the object with the matching key
		isAvailable.value = [];
		const itemCode = props.item?.code || null;
		const attrData = props.item?.item_type_config?.attribute_data ? Object.values(props.item?.item_type_config?.attribute_data) : [];
		if(!itemCode || !attrData) return;

		if(itemCode && attrData?.length > 1) {
			let foundObject = null;
			const productData = props.item?.item_type_config?.product_data;
			if(!productData) return;

			for (const key in productData) {
				if (productData[key].code === itemCode) {
					foundObject = productData[key];
					break;
				}
			}

			if (foundObject) {
				const matchingObjects = [];

				for (const key in productData) {
					const attrItemsIds = productData[key]?.configurable_attribute_items_ids || [];
					if (attrItemsIds.includes(foundObject.configurable_attribute_items_ids[0]) ||
						attrItemsIds.includes(foundObject.configurable_attribute_items_ids[1])) {
						matchingObjects.push(productData[key]);
					}
				}

				isAvailable.value = matchingObjects;
			}
		}
	}

	watch(
		() => bus.value,
		async (newValue) => {
			//advanced item
			if (newValue.event === 'confAvailableClass') {
				checkIfAvailable();
				bus.value.event = null;
			}
		}
	);

	function getClass(data, code, attributeId) {
		setTimeout(() => {
			//find all active attributes and exclude the attribute from the group that is clicked
			const activeVariationItems = props.item?.item_type_config?.product_data_summary ? Object.values(props.item.item_type_config.product_data_summary) : [];
			if(!activeVariationItems.length) return false;

			activeVariationItems.flatMap((variation) => Object.values(variation))
			.filter((variationItem) => variationItem.data.active == props.item.id && variationItem.data.attribute_id != attributeId)
			.map((variationItem) => variationItem.data.id);

			//add the id of attribute on which the user clicked
			activeVariationItems.push(data.data.id);

			if(isAvailable.value.length) {
				const matchingProduct = isAvailable.value.find(item =>
					item.configurable_attribute_items_ids.every(id => activeVariationItems.includes(id))
				);

				if (matchingProduct) {
					return matchingProduct.is_available ? 'available' : 'unavailable';
				} else {
					return 'hidden';
				}
			}

			return false;
		},100);
	}

	//advanced item
	let advancedItem = ref(null)
	let advancedItemTitle = ref(null)

	//advanced item attribute select
	function chooseAdvancedVar(key, title) {
		advancedItem.value = key;
		advancedItemTitle.value = title;

		emit('advancedItem', {'advancedItem': key, 'advancedItemTitle': title});
	}

	onMounted(() => {
		const firstKey = (props.item.type_config) ? Object.keys(props.item.type_config)[0] : null;
		advancedItem.value = firstKey
		advancedItemTitle.value = (firstKey) ? props.item.type_config[firstKey].title : null
		emit('advancedItem', {'advancedItem': advancedItem.value, 'advancedItemTitle': advancedItemTitle.value});
		if(props.item?.item_type_config) {
			checkIfAvailable();
		}
	});
</script>

<style lang="less" scoped>
	.variations{
		width: 100%; margin: 0; padding: 16px 0 0; border-top: 1px solid @borderColor; border-bottom: 1px solid @borderColor; position: relative;

		@media (max-width: @m){width: calc(~"100% - -30px"); margin: 0 0 0 -15px; padding: 16px 15px 0;}
	}
	.variation{
		margin-bottom: 12px; flex-grow: 1; position: relative;
		&:first-child .variation-attribute.unavailable>span:before{content: none;}
		&:first-child .variation-attribute.hidden{display: flex;}
	}
	.variation-title{font-size: 15px; line-height: 1.4; padding-bottom: 10px;}
	.variation-items{width: calc(~"100% - -8px"); margin-left: -4px; display: flex; flex-wrap: wrap; position: relative;}
	.variation-attribute{
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin: 0 4px 8px; padding: 13px 20px; background: @white; border: 1px solid @borderColor; text-align: center; color: @textColor; text-decoration: none; cursor: pointer; .transition(all);
		&.special{
			padding: 3px; border-color: transparent;
			@media (min-width: @t){
				&:hover{border-color: @borderColor;}
			}
		}
		&.active{
			background: #EBF4FF; border: 1px solid @blue;
			&.special{background: @white;}
			.title{color: @blue;}
		}
		&.unavailable{
			position: relative;
			&:before{.pseudo(auto, auto); background: linear-gradient(to top right,rgba(0,0,0,0) 0%,rgba(0,0,0,0) calc(50% - 1px),rgba(51, 51, 51, 0.25) 50%,rgba(0,0,0,0) calc(50% + 1px),rgba(0,0,0,0) 100%); top: 0; bottom: 0; left: 0; right: 0; z-index: 11;}
			&.special{
				&:before{content: none;}
				&>span{
					position: relative;
					&:before{.pseudo(auto, auto); background: linear-gradient(to top right,rgba(0,0,0,0) 0%,rgba(0,0,0,0) calc(50% - 1px),rgba(215, 228, 239, 1) 50%,rgba(0,0,0,0) calc(50% + 1px),rgba(0,0,0,0) 100%); top: 0; bottom: 0; left: 0; right: 0; z-index: 11;}
				}
			}
			&.light{
				&>span:before{.pseudo(auto, auto); background: linear-gradient(to top right,rgba(0,0,0,0) 0%,rgba(0,0,0,0) calc(50% - 1px),rgba(51, 51, 51, 0.25) 50%,rgba(0,0,0,0) calc(50% + 1px),rgba(0,0,0,0) 100%); top: 0; bottom: 0; left: 0; right: 0; z-index: 11;}
			}
		}
		&.hidden{display: none;}
		.hex-color{
			position: relative;
			.pseudo(auto,auto); top: 0; bottom: 0; left: 0; right: 0; box-shadow: inset 0 2px 5px 0 rgba(51,51,51,0.25); z-index: 1;
		}
		.img{
			display: flex; align-items: flex-start; justify-content: center; position: relative;
			&:after{.pseudo(auto,auto); top: 0; bottom: 0; left: 0; right: 0; box-shadow: inset 0 2px 5px 0 rgba(51,51,51,0.25); z-index: 1;}
			img{display: block; width: auto; height: auto; max-width: 42px; max-height: 42px;}
		}
		.title{display: block; font-size: 15px; line-height: 1.4; font-weight: 600; .transition(color);}
		@media (min-width: @t){
			&:hover{border: 1px solid @blue; text-decoration: none; color: @textColor;}
		}

		@media (max-width: @t){
			padding: 10px 17px;
			&:hover{color: @textColor;}
		}
	}
	.variation-alert{
		display: none; align-items: center; justify-content: center; width: auto; height: 24px; white-space: nowrap; padding: 0 12px; background: @white; border: 1px solid @borderColor; font-size: 12px; line-height: 18px; color: @textColor; font-weight: bold; position: absolute; top: 45%; right: calc(~"100% - -10px"); transform: translateY(-50%); visibility: visible; opacity: 1; z-index: 11; .transition(opacity);
		&:before{.pseudo(5px,5px); background: @white; border-top: 1px solid @borderColor; border-right: 1px solid @borderColor; right: -4px; top: 50%; transform: translateY(-50%) rotate(45deg);}
		&.active{display: flex;}

		@media (max-width: @t){display: none!important;}
	}
</style>
